<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>发布白名单用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="手机号"
                        prop="mobile">
            <el-input placeholder="请输入名称"
                      v-model="search.mobile"
                      clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/platform-user-whitelist/add/form'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">批量添加白名单
          </el-button>
        </router-link>
        <router-link :to="'/platform-user-whitelist/delete/form'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">批量刪除白名单
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="userid"
                         label="用户id"
                         width="100px"></el-table-column>
        <el-table-column prop="cellphone"
                         label="手机号"
                         width="110px">
          <template slot-scope="scope">
            <router-link style="text-decoration:none"
                         :to="'/users/detail/info?userid='+scope.row.userid">
              <span style="color:rgb(88,157,248);">{{scope.row.cellphone}}</span>
            </router-link>
          </template>
        </el-table-column>

        <el-table-column prop="registertime"
                         label="注册时间"></el-table-column>
        <el-table-column prop="status"
                         label="用户状态">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="item.value === parseInt(scope.row.status)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="currentstatus"
                         label="用户当前状态">
          <template slot-scope="scope">
            <span v-for="item in options.currentstatus"
                  v-if="item.value === parseInt(scope.row.currentstatus)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="160px">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="danger"
                       @click="onDelete(scope.row.userid, scope.$index, table)">
              移除白名单
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../platform-user-whitelist.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        mobile: null,
      },
      exportHeader: [
      ],
      whiteId: null

    }
  },
  computed: Vuex.mapState({
    options: state => state.users.options,
    users: state => state.login.user,
    otherOptions: state => state.users.userOptions,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryPlatformUserWhitelistData').then(({data}) => {
        params.tagids = [data.id]
        this.whiteId = data.id
        return request.page('getPlatformUserWhitelistTable', params)
      })
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportPlatformUserWhitelistData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (id, index, rows) {
      this.$confirm('此操作将移除白名单, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deletePlatformUserWhitelistData', {tags: [this.whiteId], userids: String(id)}).then(() => {
          this.$message.success('移除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消移除')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-user-whitelist/pages/PlatformUserWhitelistTable.vue